import React from "react";
import Footer from "../component/Footer";

function paneloVision() {
  return (
    <div className="Solution">
      <main className="font-nunito">
        <section className="pt-16">
          <div className="flex justify-center items-center w-full relative">
            <picture class="jumbotron-picture ">
              <source
                className="w-full max-h-max"
                media="(max-width: 767px)"
                srcset="./img/mobile-img.jpg"
              />
              <source
                className="w-full max-h-max"
                media="(min-width: 768px)"
                srcset="./img/solutionjumbo.png"
              />
              <img
                className="w-full max-h-max"
                src="./img/solutionjumbo.png"
                alt="Responsive jumbotron Image"
              />
            </picture>
            <div
              className="w-full
             flex flex-col m-auto justify-center items-center absolute top-0 bottom-0 overflow-y-hidden"
            >
              <h1 className="text-white text-2xl md:text-5xl text-center font-secular leading-relaxed">
                PANELO VISION <br /> MAKE DISPLAY SMARTER{" "}
              </h1>
              <button className="text-white bg-main-color mt-5 p-3 pl-11 pr-11 mb-5 rounded-md transition .ease-in duration-1000ms hover:bg-orange-dark">
                <a href="#">Free Trial</a>
              </button>
            </div>
          </div>
        </section>
        {/* Jumbotron Section End Here */}

        <section>
          <div className="flex flex-col lg:flex-row justify-center p-4 lg:p-20 lg:py-2 lg:pt-16 lg:px-28">
            <div className="p-5 lg:w-4/12 shadow-lg mx-2 rounded-md">
              <div className="flex flex-col items-center lg:items-baseline mb-3">
                <img
                  loading="lazy"
                  src="./img/device.png"
                  width="100"
                  className=""
                  alt=""
                />
                <h3 className="font-robotoslab mb-5 text-xl font-bold text-main-color  mt-4">
                  Edge Processing
                </h3>
              </div>
              <div className="flex flex-col justify-center items-center">
                <p className="text-center lg:text-left ">
                  No video is sent to cloud. Use Windows and Linux devices.
                  Lower TCO and Operational Cost
                </p>
              </div>
            </div>
            <div className="p-5 lg:w-4/12 shadow-lg mx-2 rounded-md">
              <div className="flex flex-col items-center lg:items-baseline mb-3">
                <img
                  loading="lazy"
                  src="./img/privacy.png"
                  width="100"
                  className=""
                  alt=""
                />
                <h3 className="font-robotoslab mb-5 text-xl font-bold text-main-color mt-4">
                  Keep The Privacy
                </h3>
              </div>
              <div className="flex flex-col justify-center items-center">
                <p className="text-center lg:text-left ">
                  100% anonymous, no video is saved
                </p>
              </div>
            </div>
            <div className="p-5 lg:w-4/12 shadow-lg mx-2 rounded-md">
              <div className="flex flex-col items-center lg:items-baseline mb-3">
                <img
                  loading="lazy"
                  src="./img/vision.png"
                  width="85"
                  className=""
                  alt=""
                />
                <h3 className="font-robotoslab mb-5 text-xl font-bold text-main-color  mt-4">
                  Machine Learning Computer Vision
                </h3>
              </div>
              <div className="flex flex-col justify-center items-center">
                <p className="text-center lg:text-left ">
                  Detect gender, age, emotion, distant, screen time, people and
                  vehicle counting, vehicle classification
                </p>
              </div>
            </div>
            <div className="p-5 lg:w-4/12 shadow-lg mx-2 rounded-md">
              <div className="flex flex-col items-center lg:items-baseline mb-3">
                <img
                  loading="lazy"
                  src="./img/friendly.png"
                  width="80"
                  className=""
                  alt=""
                />
                <h3 className="font-robotoslab mb-5 text-xl font-bold text-main-color  mt-4">
                  User Friendly
                </h3>
              </div>
              <div className="flex flex-col justify-center items-center">
                <p className="text-center lg:text-left ">
                  Easy to user, easy to integrate with more capabilities into
                  vehicle and people tracking ​
                </p>
              </div>
            </div>
          </div>
        </section>

        <section>
          <h2 className="text-black text-3xl lg:text-4xl pt-16 mb-5 font-bold text-center">
            FEATURES
          </h2>

          <div className="solution flex flex-col lg:flex-row justify-center p-4 lg:px-28">
            <div className="shadow-lg hover:shadow-xl rounded-md lg:w-5/12 p-4 mx-6 mb-9">
              <div className="font-poppins">
                <ul className="list-disc pl-6">
                  <li className="border-b py-4">
                    Count the number of people looking at the screen with screen
                    time as well as the display currently being played
                  </li>
                  <li className="border-b py-9">
                    Detect gender, age, emotion, distant, screen time, people
                    and vehicle counting, vehicle classification
                  </li>
                  <li className="border-b py-9">Analytics dashboard</li>
                  <li className="border-b py-9">
                    Integration capability (Rest API, HTTP, Broadcast)
                  </li>
                  <li className="border-b py-9">
                    Support for webcams, IP cameras
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>

        {/* 3 easy step Section Start Here */}
        <section className="mb-9 mt-9">
          <div className="bg-main-color flex flex-col justify-center items-center p-10">
            <h1 className="text-white text-3xl lg:text-4xl font-bold">
              HOW TO START ?
            </h1>
            <p className="uppercase text-white px-10 lg:px-80 text-center mb-4 mt-4">
              Register a free account, install Panelo Vision on your device.
              Start collecting data and view it in analytics dashboard.
            </p>
            <button className="text-main-color font-bold uppercase bg-white p-3 pl-11 pr-11 rounded-md transition .ease-in duration-1000ms hover:text-white hover:bg-orange-dark">
              <a href="#">Register Now</a>
            </button>
          </div>
          <h2 className="text-black text-3xl lg:text-4xl pt-16 mb-7 font-bold text-center p-3">
            HOW IT WORKS
          </h2>

          <div className="solution flex flex-col lg:flex-row justify-center p-4 lg:px-28">
            <div className="lg:w-4/12 p-4 mx-6 shadow-md rounded-md">
              <div className="flex flex-col items-center">
                <h3 className="font-robotoslab mt-2 mb-9 text-xl font-bold text-desc-text text-center">
                  Install
                </h3>
                <img
                  loading="lazy"
                  src="./img/mobile-login.png"
                  width="200"
                  className=""
                  alt=""
                />
                ​
              </div>
              <div className="flex flex-col justify-center items-center">
                <p className="text-center">
                  You install Panelo Vision on Windows device (digital signage
                  or media player) with connected IP or web camera.
                </p>
              </div>
            </div>
            <div className="lg:w-4/12 p-4 mx-6 shadow-md rounded-md">
              <div className="flex flex-col items-center">
                <h3 className="font-robotoslab mt-2 mb-9 text-xl font-bold text-desc-text text-center">
                  Estimate
                </h3>
                <img
                  loading="lazy"
                  src="./img/content.png"
                  width="275"
                  className=""
                  alt=""
                />
                ​
              </div>
              <div className="flex flex-col justify-center items-center">
                <p className="text-center">
                  Our proprietary software, running on device (not cloud)
                  determines and tracks every person looking at the display
                  estimating their age, gender, emotions and measures well time.
                </p>
              </div>
            </div>
            <div className="lg:w-4/12 p-4 mx-6 shadow-md rounded-md">
              <div className="flex flex-col items-center">
                <h3 className="font-robotoslab mt-2 text-xl font-bold text-desc-text text-center">
                  Analyze
                </h3>
                ​
                <img
                  loading="lazy"
                  src="./img/publication.png"
                  width="220"
                  className=""
                  alt=""
                />
              </div>
              <div className="flex flex-col justify-center items-center ">
                <p className="text-center">
                  Collected data is then sent to the analytics dashboard in real
                  time. Statistics is available online 24/7.
                </p>
              </div>
            </div>
          </div>
        </section>
        {/* Hardware Section End Here */}

        <section className="mb-10">
          <h2 className="text-black text-3xl lg:text-4xl pt-16 mb-7 font-bold text-center">
            USE CASES
          </h2>
          <div className="flex flex-col items-center lg:flex-row justify-center pt-10">
            <div className="mx-4">
              <img src="./img/usecases.png" width="500" alt="" />
            </div>
            <div>
              <div className="flex mx-4 pt-12 lg:pt-0">
                <button className="text-white font-poppins  bg-main-color  p-3 px-6 mb-5 mx-2 rounded-xl transition .ease-in duration-1000ms hover:bg-orange-dark">
                  <a href="#">Digital Signage</a>
                </button>
                <button className="text-white font-poppins  bg-main-color  p-3 px-6 mb-5 mx-2 rounded-xl transition .ease-in duration-1000ms hover:bg-orange-dark">
                  <a href="#">Retail Analytics</a>
                </button>
              </div>
              <div className="flex mx-4">
                <button className="text-white font-poppins  bg-main-color mt-3 p-3 px-6 mb-5 mx-2 rounded-xl transition .ease-in duration-1000ms hover:bg-orange-dark">
                  <a href="#">Video Analytics</a>
                </button>
                <button className="text-white font-poppins  bg-main-color mt-3 p-3 px-6 mb-5 mx-2 rounded-xl transition .ease-in duration-1000ms hover:bg-orange-dark">
                  <a href="#">DooH Advertisement</a>
                </button>
              </div>
              <div className="flex mx-4">
                <button className="text-white font-poppins  bg-main-color mt-3 p-3 px-6 mb-5 mx-2 rounded-xl transition .ease-in duration-1000ms hover:bg-orange-dark">
                  {" "}
                  <a href="#">Traffic Count</a>
                </button>
                <button className="text-white font-poppins  bg-main-color mt-3 p-3 px-6 mb-5 mx-2 rounded-xl transition .ease-in duration-1000ms hover:bg-orange-dark">
                  <a href="#">Videowall</a>
                </button>
              </div>
            </div>
          </div>
        </section>

        <section className="pb-28 mt-10">
          <h2 className="text-heading-color text-3xl lg:text-4xl pt-11 mb-5 font-bold text-center">
            JOIN WITH US
          </h2>
          <form class="bg-white rounded px-6 lg:px-8 pt-6 pb-8 mb-4 lg:mx-44 font-poppins">
            <div class="mb-4">
              <label class="block text-gray-700 text-md  mb-2" for="username">
                Company<span className="text-red-600">*</span>
              </label>
              <input
                class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                id="company_name"
                type="text"
                placeholder="Your company name"
              />
            </div>
            <div class="mb-6">
              <label class="block text-gray-700 text-md  mb-2" for="email">
                Email Address<span className="text-red-600">*</span>
              </label>
              <input
                class="shadow appearance-none border  rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                id="email"
                type="email"
                placeholder="Your@mail.com"
              />
            </div>
            <div class="mb-6">
              <label class="block text-gray-700 text-md  mb-2" for="phone">
                Mobile Phone<span className="text-red-600">*</span>
              </label>
              <input
                class="shadow appearance-none border  rounded w-full py-2 px-3 text-gray-700  leading-tight focus:outline-none focus:shadow-outline"
                id="tel"
                type="tel"
                placeholder="Enter your phone number"
              />
            </div>
            <div class="mb-6">
              <label class="block text-gray-700 text-md  mb-2" for="phone">
                Message
              </label>
              <textarea
                class="shadow appearance-none border  rounded w-full py-2 px-3 text-gray-700  leading-tight focus:outline-none focus:shadow-outline"
                rows="4"
                cols="50"
                name="comment"
                form="usrform"
              ></textarea>
            </div>

            <div class="flex items-center justify-center">
              <button
                class="bg-main-color hover:bg-orange-dark text-white py-2 px-12 rounded focus:outline-none focus:shadow-outline"
                type="button"
              >
                Submit
              </button>
            </div>
          </form>
        </section>

        <Footer />
      </main>
    </div>
  );
}

export default paneloVision;
